<template>
  <div class="review-box">
    <i class="disabled-icon el-icon-warning"></i>
    <div class="text">因违反社区公约，该帖子已被删除</div>
    <div class="text">文明发帖，共同维护社区环境</div>
    <!-- 判断文章是否有内容 -->
    <el-button v-if="detail.id" type="primary" @click="goEdit">去修改</el-button>
    <!-- 违规图片 -->
    <div class="ban-img-list">
      <img v-for="(src, index) in banImgList" :key="index" :src="src" alt="" @click="$imgViewShow(banImgList, index)" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
// plugins
import { getArticleEditorRoute } from "../../../../plugins/util";

export default {
  name: "detailDisabled",
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["gameInfo"]),
    banImgList() {
      return this.detail.ban_image_list ? this.detail.ban_image_list : [];
    }
  },
  mounted() {
    // console.log(this.detail);
  },
  methods: {
    // 前往编辑页
    goEdit() {
      const { game, editor_type, id } = this.detail;
      const { alias } = game;
      const route = getArticleEditorRoute(alias, id, editor_type);
      this.$router.push(route);
    }
  }
};
</script>

<style scoped lang="less">
.review-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;
  .disabled-icon {
    font-size: 120px;
    color: #e24646;
  }
  .text {
    font-size: 16px;
    margin-top: 10px;
    text-align: center;
  }
  .el-button {
    width: 180px;
    margin-top: 40px;
  }

  .ban-img-list {
    display: flex;
    flex-wrap: wrap;
    gap: 13px 13px;
    margin-top: 58px;
    img {
      width: 160px;
      height: 160px;
      border-radius: 8px;
      object-fit: cover;
      // border: 1px solid #e3e3e3;
      background-color: #fff;
      cursor: pointer;
    }
  }
}
</style>
